const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

const DEFAULT_LOCALE = "en-US";

export function formatTimestamp(
  date: string | number | Date | null | undefined,
  locale: string = DEFAULT_LOCALE
): string {
  if (!date) return "";
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return "";
  return new Intl.DateTimeFormat(locale, DATE_FORMAT_OPTIONS).format(parsed);
}

const CALENDAR_DAY_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
  year: "numeric",
  timeZone: "UTC",
};

/**
 * Formats an ISO date string (e.g. "2026-06-15") as a UTC calendar day, so the day is stable
 * regardless of the viewer's timezone. Returns `fallback` when the date is missing or unparseable;
 * the caller supplies the placeholder that matches its surface (e.g. "—" on the Details tab,
 * "-" on shipment cards).
 */
export function formatUtcCalendarDay(dateString: string | null | undefined, fallback = "-"): string {
  if (!dateString) return fallback;
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString(undefined, CALENDAR_DAY_OPTIONS);
}

const DATE_ONLY_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "numeric",
  day: "numeric",
  year: "numeric",
};

export function formatDate(date: string | number | Date | null | undefined, locale: string = DEFAULT_LOCALE): string {
  if (!date) return "";
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return "";
  return new Intl.DateTimeFormat(locale, DATE_ONLY_FORMAT_OPTIONS).format(parsed);
}
